import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SearchModule } from '@ibe.components/booking/search/search.module';
import { SVGModule } from '@ibe.components/common/svg/svg.module';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { TAPPageNotFoundComponent } from './page-not-found/page-not-found.tap.component';

@NgModule({
	imports: [
		CommonModule,
		SVGModule,
		RouterModule,
		SearchModule
	],
	declarations: [
		PageNotFoundComponent,
		TAPPageNotFoundComponent,
	],
	exports: [
		CommonModule,
		SVGModule,
		RouterModule,
		SearchModule
	]
})
export class TAPNotFoundModule { }
